'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdMonetizationOn = function MdMonetizationOn(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.3 30.2c2.9-0.6 5.3-2.2 5.3-5.3 0-4.2-3.7-5.7-7.1-6.5s-4.3-1.8-4.3-3.2c0-1.6 1.5-2.8 4-2.8 2.6 0 3.6 1.3 3.6 3.1h3.3c-0.1-2.5-1.6-4.8-4.8-5.6v-3.3h-4.4v3.3c-2.9 0.6-5.2 2.4-5.2 5.3 0 3.5 2.8 5.1 7 6.1 3.7 0.9 4.4 2.2 4.4 3.6 0 1-0.7 2.7-3.9 2.7-3.1 0-4.3-1.4-4.5-3.1h-3.3c0.2 3.2 2.7 5 5.5 5.6v3.3h4.4v-3.2z m-2.3-26.8c9.2 0 16.6 7.4 16.6 16.6s-7.4 16.6-16.6 16.6-16.6-7.4-16.6-16.6 7.4-16.6 16.6-16.6z' })
        )
    );
};

exports.default = MdMonetizationOn;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/monetization-on.js
// module id = 2555
// module chunks = 0